import { Component,OnInit } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd';
import {MenuService, SettingsService} from '@delon/theme';
import { PersonService } from "../../../routes/jy-org/person/service/person.service";
import {StartupService} from "@core/startup/startup.service";

@Component({
  selector   : 'layout-sidebar',
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent implements OnInit{
  constructor(public settings: SettingsService, public msgSrv: NzMessageService,public personService:PersonService,private startupService:StartupService,private menuService:MenuService) {
  }
  ngOnInit(){
  }

  refreshMenu(){
    this.startupService.reloadMenuTodoData();
  }

  //  搜索栏
  public defaultMenuList = [];//将系统默认菜单存储
  public defaultMenuBol:boolean = false;//判断是否为第一次搜索，第一次搜索时将菜单存储起来
  public searchText:string = '';
  public timeout:any;
  searchTextChange(e){
    if(this.timeout){
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(()=>{
      if(!this.defaultMenuBol && !(this.menuService.menus && this.menuService.menus.length > 0)){
        return;
      }
      if(!this.defaultMenuBol){
        this.defaultMenuList = this.menuService.menus;
        this.defaultMenuBol = true;
      }
      let menuList = [];
      if(this.searchText){
        if(this.defaultMenuList){
          this.defaultMenuList.forEach((item1) => {
            if(item1.children && item1.children.length){
              item1.children.forEach((item2) => {
                if(item2.text.indexOf(e) > -1){
                  menuList.push(item2);
                }else if(item2.children && item2.children.length){
                  item2.children.forEach((item3) => {
                    if(item3.text.indexOf(e) > -1){
                      menuList.push(item3);
                    }
                  })
                }
              })
            }else{
              if(item1.text.indexOf(e) > -1){
                menuList.push(item1);
              }
            }
          })
        }
        this.menuService.add([{children:menuList,text:this.searchText}]);
      }else{
        this.menuService.add(this.defaultMenuList);
        menuList = this.defaultMenuList;
      }
    },300);
  }

  clearData(){
    this.searchText = '';
    this.searchTextChange('');
  }
}
